'use strict'

exports = module.exports = require('./build/input').default

module.exports['default'] = require('./build/input').default


//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/custom.js
// module id = 1182
// module chunks = 0